import { render } from "./Column202504.vue?vue&type=template&id=1ce4f041&scoped=true"
import script from "./Column202504.vue?vue&type=script&lang=js"
export * from "./Column202504.vue?vue&type=script&lang=js"

import "./Column202504.vue?vue&type=style&index=0&id=1ce4f041&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1ce4f041"

export default script